// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._B2FOoW4wHPKb4Mizai8{min-height:unset;padding:16px 20px 12px}.mqy2zOayJkAB94RbJlV9{margin-bottom:32px;padding-left:20px}.fIC3qlSDgjEXUSvpywOq{flex-grow:1;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `_B2FOoW4wHPKb4Mizai8`,
	"wrapStatus": `mqy2zOayJkAB94RbJlV9`,
	"content": `fIC3qlSDgjEXUSvpywOq`
};
export default ___CSS_LOADER_EXPORT___;
